import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import PoiThumbnail from './PoiThumbnail'
import { usePois } from '../../contexts/PoisContext'

const VillageEvents = ({ poi }) => {
  const { t } = useTranslation()
  const { pois } = usePois()

  const [villageEvents, setVillageEvents] = useState([])

  useEffect(() => {
    if (!pois) return

    // Filtrer les POIs qui sont des événements et dans la même ville que poi.city.name
    const filteredEvents = pois.filter(
      (p) => p.isEvent === true && p.city?.name === poi.city?.name,
    )
    setVillageEvents(filteredEvents)
  }, [pois, poi.city?.name])

  if (!villageEvents.length) return null

  return (
    <div className="mt-4">
      <hr />
      <h2 className="mb-4">{t('EVENTS')}</h2>
      <div className="row g-4">
        {villageEvents.map((villageEvent) => (
          <div className="col-md-6 col-lg-4 d-flex" key={villageEvent.id}>
            <PoiThumbnail poi={villageEvent} isCategory={false} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default VillageEvents
